import { ObjectDirective, nextTick } from 'vue';
import HSStickyBlock from '../../vendor/hs-sticky-block/dist/hs-sticky-block'

export const vStickyBlock = {
    mounted(el, binding) {

        // Store the original options on the element
        el._stickyOptions = { ...binding.value };

        // Delay initialization to ensure proper rendering of nested components
        nextTick(() => {
            initStickyBlock(el, binding);
        }, 100);
    },
    updated(el, binding) {

        el._stickyOptions = { ...binding.value }; // Update stored options
        if (el._stickyBlock && typeof el._stickyBlock.update === 'function') {
            safeUpdate(el, binding.value);
        }
    },
    unmounted(el) {
        cleanupStickyBlock(el);
    }
};

function initStickyBlock(el, binding) {
    let isSticky = false;
    const options = { ...binding.value };

    // Ensure parent element is positioned for correct sticky behavior
    const parent = document.querySelector(options.parentSelector);
    if (parent) {
        const parentPosition = window.getComputedStyle(parent).position;
        if (parentPosition === 'static') {
            parent.style.position = 'relative';
        }
    }

    const checkStickyState = () => {
        if (!el.isConnected) return; // Check if element is still in the DOM

        const wasSticky = isSticky;
        const computedStyle = window.getComputedStyle(el);
        isSticky = computedStyle.position === 'fixed';

        if (isSticky) {
            el.style.zIndex = 99;
        } else {
            el.style.zIndex = '';
        }

        if (wasSticky !== isSticky && typeof options.onSticky === 'function') {
            try {
                options.onSticky(isSticky);
            } catch (error) {
                console.error('Error in user onSticky callback', error);
            }
        }
    };

    el._stickyBlock = new HSStickyBlock(el, options);

    // Wrap HSStickyBlock's update method
    const originalUpdate = el._stickyBlock.update;
    el._stickyBlock.update = function (...args) {
        if (el.isConnected) {
            return originalUpdate.apply(this, args);
        }
    };

    // Initial check
    checkStickyState();

    // Add scroll and resize listeners for sticky state detection
    const checkSticky = () => {
        requestAnimationFrame(checkStickyState);
    };

    window.addEventListener('scroll', checkSticky, { passive: true });
    window.addEventListener('resize', checkSticky, { passive: true });
    el._checkSticky = checkSticky;
}

function safeUpdate(el, value) {
    if (el.isConnected && el._stickyBlock) {
        try {
            el._stickyBlock.update(el, value);
        } catch (error) {
            console.error('Error updating sticky block:', error);
        }
    }
}

function cleanupStickyBlock(el) {

    // Safely remove event listeners
    window.removeEventListener('resize', el._checkSticky);
    window.removeEventListener('scroll', el._checkSticky);

    if (el._stickyBlock) {
        window.removeEventListener('resize', el._stickyBlock.update);
        window.removeEventListener('scroll', el._stickyBlock.update);
    }

    // Attempt to reset styles safely
    if (el.isConnected) {
        try {
            el.style.position = '';
            el.style.top = '';
            el.style.bottom = '';
            el.style.left = '';
            el.style.width = '';
            el.style.zIndex = '';
        } catch (error) {
            console.error('Error resetting styles during cleanup:', error);
        }
    }

    // Attempt to reset parent height safely
    if (el._stickyOptions?.parentSelector) {
        const parent = document.querySelector(el._stickyOptions.parentSelector);
        if (parent?.isConnected) {
            try {
                parent.style.height = '';
            } catch (error) {
                console.error('Error resetting parent height during cleanup:', error);
            }
        }
    }

    el._stickyBlock = undefined;
    el._checkSticky = undefined;
    el._stickyOptions = undefined;
}